module.exports = __webpack_public_path__ + "img/gun-squirt.f7ba25ae.svg";